var map = {
	"./google-laurel-da-DK.svg": 46254,
	"./google-laurel-de-DE.svg": 11692,
	"./google-laurel-en-GB.svg": 53481,
	"./google-laurel-en-US.svg": 92589,
	"./google-laurel-es-ES.svg": 86294,
	"./google-laurel-es-MX.svg": 58805,
	"./google-laurel-fr-FR.svg": 41622,
	"./google-laurel-it-IT.svg": 45588,
	"./google-laurel-nb-NO.svg": 91723,
	"./google-laurel-nl-NL.svg": 39442,
	"./google-laurel-pl-PL.svg": 36010,
	"./google-laurel-pt-BR.svg": 67958,
	"./google-laurel-pt-PT.svg": 86634,
	"./google-laurel-sv-SE.svg": 67031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39909;